module.exports = __webpack_public_path__ + "img/kakao_btn.33b52b20.png";